import { BaseIcon } from './base-icon.js';
import { svg } from 'lit';

/**
 * Info Filled Icon Component
 * Filled circle with "i" symbol (solid style)
 * Used for emphasized informational messages
 */
class InfoFilledIcon extends BaseIcon {
    getSvgAttributes() {
        return {
            xmlns: 'http://www.w3.org/2000/svg',
            viewBox: '0 0 24 24',
            fill: 'currentColor',
        };
    }

    renderIconPath() {
        return svg`
            <path
                fill-rule="evenodd"
                d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                clip-rule="evenodd"
            />
        `;
    }
}

customElements.define('info-filled-icon', InfoFilledIcon);
